import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../../lib/LangContext";

/** Short notice shown directly beside any form that collects personal data. */
export const PrivacyNote = ({ purpose, testId = "form-privacy-note", className = "" }) => {
  const { tr } = useLang();
  return (
    <p data-testid={testId} className={`text-xs leading-relaxed text-slate-500 ${className}`}>
      {tr(purpose)}{" "}
      {tr("We never sell your details.")}{" "}
      <Link to="/legal/privacy-policy" className="font-semibold text-[#F95738] hover:underline">
        {tr("Privacy Policy")}
      </Link>
    </p>
  );
};

export default PrivacyNote;
